import Vue from 'vue'

Vue.filter('redGreen', (value, redValue, greenValue, suffix) => {
  if (!suffix) suffix = ''
  if (value === true) {
    return 'positive' + suffix
  }
  if (value === false) {
    return 'negative' + suffix
  }

  if (redValue && value === redValue) {
    return 'positive' + suffix
  }
  if (greenValue && value === greenValue) {
    return 'negative' + suffix
  }

  if (value > 0) {
    return 'positive' + suffix
  }
  if (value < 0) {
    return 'negative' + suffix
  }
})
